export interface ComicCategory {
  slug: string;
  name: string;
  icon: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  coverImage: string;
  description: string;
  rating: number;
  views: number;
  tags: string[];
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  createdAt: string;
}

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    title: '再见，我的公主',
    author: '金秀雅',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20princess%20character%20with%20flowing%20hair%2C%20soft%20pastel%20color%20palette%2C%20elegant%20royal%20palace%20background%2C%20clean%20composition%20with%20minimalist%20aesthetic%2C%20watercolor%20texture%2C%20emotional%20and%20delicate%20atmosphere&width=600&height=840&seq=comic-cover-01&orientation=portrait',
    description: '在遥远的王国里，一位公主为了守护自己的爱情，勇敢地对抗着命运的枷锁。当她遇见了命中注定的骑士，一切都发生了改变。这是一个关于勇气、爱情与成长的动人故事。',
    rating: 9.5,
    views: 1280000,
    tags: ['恋爱', '宫廷', '成长'],
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: '1-1', title: '第1话：命运的相遇', number: 1, createdAt: '2026-01-15' },
      { id: '1-2', title: '第2话：王国的秘密', number: 2, createdAt: '2026-01-22' },
      { id: '1-3', title: '第3话：骑士的誓言', number: 3, createdAt: '2026-01-29' },
      { id: '1-4', title: '第4话：花园的告白', number: 4, createdAt: '2026-02-05' },
      { id: '1-5', title: '第5话：王室的考验', number: 5, createdAt: '2026-02-12' },
    ],
  },
  {
    id: '2',
    title: '魔王的继承者',
    author: '李志勋',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20dark%20mage%20character%20with%20magical%20aura%2C%20mysterious%20ancient%20temple%20background%2C%20cool%20color%20tone%20with%20purple%20and%20dark%20blue%20accents%2C%20epic%20atmosphere%2C%20clean%20composition&width=600&height=840&seq=comic-cover-02&orientation=portrait',
    description: '普通高中生李贤宇在某天突然发现自己竟然是魔王的转世。面对突如其来的力量与责任，他必须在光明与黑暗之间做出选择。一场震撼天界的冒险即将展开！',
    rating: 9.3,
    views: 986000,
    tags: ['奇幻', '冒险', '魔法'],
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: '2-1', title: '第1话：觉醒之日', number: 1, createdAt: '2026-02-01' },
      { id: '2-2', title: '第2话：暗影降临', number: 2, createdAt: '2026-02-08' },
      { id: '2-3', title: '第3话：力量之源', number: 3, createdAt: '2026-02-15' },
    ],
  },
  {
    id: '3',
    title: '校园风云录',
    author: '崔美英',
    category: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20comedy%20cover%20art%2C%20cheerful%20students%20in%20school%20uniform%2C%20bright%20and%20vibrant%20colors%2C%20classroom%20background%20with%20sunlight%2C%20playful%20and%20energetic%20atmosphere%2C%20clean%20illustration%20style&width=600&height=840&seq=comic-cover-03&orientation=portrait',
    description: '转学生林小美来到新学校后，凭借自己独特的性格和才能，在校园中掀起了一阵阵欢乐的风暴。与各种性格迥异的同学们之间发生的趣事，让人捧腹大笑的同时又充满温暖。',
    rating: 9.1,
    views: 856000,
    tags: ['搞笑', '校园', '青春'],
    status: '已完结',
    updatedAt: '2026-07-20',
    chapters: [
      { id: '3-1', title: '第1话：转校生登场', number: 1, createdAt: '2026-03-01' },
      { id: '3-2', title: '第2话：班级大乱斗', number: 2, createdAt: '2026-03-08' },
      { id: '3-3', title: '第3话：运动会风云', number: 3, createdAt: '2026-03-15' },
      { id: '3-4', title: '第4话：毕业季', number: 4, createdAt: '2026-03-22' },
    ],
  },
  {
    id: '4',
    title: '暗夜追踪者',
    author: '朴正宇',
    category: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20cover%20art%2C%20detective%20character%20in%20trench%20coat%2C%20dark%20alley%20at%20night%20with%20neon%20lights%2C%20suspenseful%20atmosphere%2C%20high%20contrast%20lighting%2C%20film%20noir%20style%2C%20clean%20composition&width=600&height=840&seq=comic-cover-04&orientation=portrait',
    description: '首尔深夜的街头，一系列离奇案件接连发生。刑警姜道贤在追查真相的过程中，逐渐揭开了一个惊天阴谋的面纱。每一条线索都指向一个他无法想象的黑暗世界。',
    rating: 9.4,
    views: 1120000,
    tags: ['悬疑', '推理', '都市'],
    status: '连载中',
    updatedAt: '2026-08-05',
    chapters: [
      { id: '4-1', title: '第1话：深夜来电', number: 1, createdAt: '2026-04-01' },
      { id: '4-2', title: '第2话：第一起案件', number: 2, createdAt: '2026-04-08' },
      { id: '4-3', title: '第3话：证人的消失', number: 3, createdAt: '2026-04-15' },
      { id: '4-4', title: '第4话：隐藏的线索', number: 4, createdAt: '2026-04-22' },
      { id: '4-5', title: '第5话：真相逼近', number: 5, createdAt: '2026-04-29' },
      { id: '4-6', title: '第6话：黑暗深处', number: 6, createdAt: '2026-05-06' },
    ],
  },
  {
    id: '5',
    title: '星光咖啡馆',
    author: '尹智恩',
    category: 'daily',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20cafe%20setting%20with%20warm%20lighting%2C%20barista%20character%2C%20soft%20pastel%20warm%20colors%2C%20relaxing%20atmosphere%2C%20clean%20illustration%20style%2C%20comfortable%20vibe&width=600&height=840&seq=comic-cover-05&orientation=portrait',
    description: '在首尔一条安静的小巷里，有一家名为「星光」的咖啡馆。店主尹星每天都会遇到不同的客人，聆听他们的故事，用一杯温暖的咖啡治愈每一颗疲惫的心。',
    rating: 9.0,
    views: 723000,
    tags: ['日常', '治愈', '美食'],
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: '5-1', title: '第1话：开业第一天', number: 1, createdAt: '2026-05-01' },
      { id: '5-2', title: '第2话：第一位客人', number: 2, createdAt: '2026-05-08' },
      { id: '5-3', title: '第3话：雨天的故事', number: 3, createdAt: '2026-05-15' },
    ],
  },
  {
    id: '6',
    title: '战神归来',
    author: '姜太元',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20martial%20arts%20cover%20art%2C%20powerful%20warrior%20character%20with%20martial%20arts%20stance%2C%20dynamic%20pose%2C%20ancient%20oriental%20temple%20background%2C%20intense%20color%20with%20red%20and%20gold%20accents%2C%20epic%20atmosphere&width=600&height=840&seq=comic-cover-06&orientation=portrait',
    description: '曾经被称为战神的天界第一高手，因一场阴谋被贬下凡间。重生为普通人的他，凭借前世的记忆与战斗经验，一步步重新崛起，誓要重返天界，夺回属于自己的一切！',
    rating: 9.6,
    views: 1560000,
    tags: ['动作', '热血', '重生'],
    status: '连载中',
    updatedAt: '2026-08-05',
    chapters: [
      { id: '6-1', title: '第1话：陨落', number: 1, createdAt: '2026-06-01' },
      { id: '6-2', title: '第2话：凡间重生', number: 2, createdAt: '2026-06-08' },
      { id: '6-3', title: '第3话：初次试炼', number: 3, createdAt: '2026-06-15' },
      { id: '6-4', title: '第4话：突破极限', number: 4, createdAt: '2026-06-22' },
    ],
  },
  {
    id: '7',
    title: '悲伤恋歌',
    author: '张美淑',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20melodrama%20cover%20art%2C%20couple%20characters%20in%20emotional%20scene%2C%20autumn%20leaves%20falling%20background%2C%20warm%20but%20melancholic%20color%20tone%2C%20poetic%20atmosphere%2C%20clean%20illustration%20style%2C%20delicate%20emotional%20expression&width=600&height=840&seq=comic-cover-07&orientation=portrait',
    description: '两个相爱的人因为家族的恩怨而不能在一起。命运一次次将他们拆散，又一次次让他们相遇。这是一个关于爱情、牺牲与坚守的催泪故事。',
    rating: 9.2,
    views: 892000,
    tags: ['剧情', '爱情', '悲剧'],
    status: '已完结',
    updatedAt: '2026-06-30',
    chapters: [
      { id: '7-1', title: '第1话：初雪', number: 1, createdAt: '2026-04-01' },
      { id: '7-2', title: '第2话：重逢', number: 2, createdAt: '2026-04-08' },
      { id: '7-3', title: '第3话：裂痕', number: 3, createdAt: '2026-04-15' },
      { id: '7-4', title: '第4话：诀别', number: 4, createdAt: '2026-04-22' },
      { id: '7-5', title: '第5话：终章', number: 5, createdAt: '2026-04-29' },
    ],
  },
  {
    id: '8',
    title: '守护灵契约',
    author: '韩在熙',
    category: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20fantasy%20cover%20art%2C%20girl%20character%20with%20spirit%20animal%20companion%2C%20magical%20forest%20background%20with%20glowing%20particles%2C%20mystical%20atmosphere%2C%20soft%20green%20and%20gold%20color%20palette%2C%20clean%20composition&width=600&height=840&seq=comic-cover-08&orientation=portrait',
    description: '少女朴素媛在一次意外中与传说中的守护灵缔结了契约。从此，她能看见常人无法看见的灵体世界。在这个充满神秘的世界里，她将揭开家族隐藏了数百年的秘密。',
    rating: 9.3,
    views: 768000,
    tags: ['奇幻', '灵异', '冒险'],
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: '8-1', title: '第1话：灵视', number: 1, createdAt: '2026-07-01' },
      { id: '8-2', title: '第2话：契约', number: 2, createdAt: '2026-07-08' },
      { id: '8-3', title: '第3话：灵界入口', number: 3, createdAt: '2026-07-15' },
    ],
  },
  {
    id: '9',
    title: '霸道总裁爱上我',
    author: '郑恩星',
    category: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%20art%2C%20elegant%20businessman%20and%20female%20protagonist%20in%20modern%20office%20setting%2C%20chic%20urban%20background%2C%20stylish%20fashionable%20character%20design%2C%20sophisticated%20color%20palette%2C%20clean%20composition&width=600&height=840&seq=comic-cover-09&orientation=portrait',
    description: '普通上班族金多惠意外成为了公司总裁的私人助理。原本以为只是一份普通工作，没想到却卷入了一段甜蜜又刺激的办公室恋情。霸道总裁的温柔，让她一步步沦陷。',
    rating: 9.0,
    views: 1340000,
    tags: ['恋爱', '职场', '甜宠'],
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: '9-1', title: '第1话：面试意外', number: 1, createdAt: '2026-05-01' },
      { id: '9-2', title: '第2话：第一天上班', number: 2, createdAt: '2026-05-08' },
      { id: '9-3', title: '第3话：加班之夜', number: 3, createdAt: '2026-05-15' },
      { id: '9-4', title: '第4话：出差之旅', number: 4, createdAt: '2026-05-22' },
    ],
  },
  {
    id: '10',
    title: '末日求生指南',
    author: '吴镇宇',
    category: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20survival%20cover%20art%2C%20survivor%20characters%20in%20ruined%20cityscape%2C%20dramatic%20lighting%20with%20orange%20sunset%2C%20intense%20and%20gritty%20atmosphere%2C%20action%20oriented%20composition%2C%20clean%20illustration%20style&width=600&height=840&seq=comic-cover-10&orientation=portrait',
    description: '一场突如其来的病毒席卷全球，人类文明在一夜之间崩塌。普通上班族郑明浩带领着一群幸存者，在废墟中艰难求生。他们不仅要面对丧尸的威胁，更要提防人性中最黑暗的一面。',
    rating: 9.4,
    views: 1050000,
    tags: ['动作', '末世', '生存'],
    status: '连载中',
    updatedAt: '2026-08-05',
    chapters: [
      { id: '10-1', title: '第1话：爆发', number: 1, createdAt: '2026-06-15' },
      { id: '10-2', title: '第2话：逃亡', number: 2, createdAt: '2026-06-22' },
      { id: '10-3', title: '第3话：避难所', number: 3, createdAt: '2026-06-29' },
      { id: '10-4', title: '第4话：背叛', number: 4, createdAt: '2026-07-06' },
      { id: '10-5', title: '第5话：新的希望', number: 5, createdAt: '2026-07-13' },
    ],
  },
  {
    id: '11',
    title: '时间旅行者的恋人',
    author: '金秀雅',
    category: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20time%20travel%20romance%20cover%20art%2C%20couple%20characters%20with%20clock%20and%20time%20motif%2C%20dreamy%20surreal%20background%20with%20floating%20clock%20elements%2C%20soft%20blue%20and%20pink%20color%20palette%2C%20romantic%20atmosphere&width=600&height=840&seq=comic-cover-11&orientation=portrait',
    description: '物理学家李在民发明了时间旅行装置，却意外穿越到了10年前。在那里，他遇见了已经去世的恋人。他能否改变过去，拯救爱人的生命？还是说，时间早已注定了一切？',
    rating: 9.5,
    views: 945000,
    tags: ['剧情', '科幻', '爱情'],
    status: '已完结',
    updatedAt: '2026-07-15',
    chapters: [
      { id: '11-1', title: '第1话：穿越', number: 1, createdAt: '2026-03-01' },
      { id: '11-2', title: '第2话：十年前的你', number: 2, createdAt: '2026-03-08' },
      { id: '11-3', title: '第3话：蝴蝶效应', number: 3, createdAt: '2026-03-15' },
      { id: '11-4', title: '第4话：最终选择', number: 4, createdAt: '2026-03-22' },
    ],
  },
  {
    id: '12',
    title: '猫咪咖啡馆的日常',
    author: '崔美英',
    category: 'daily',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cat%20cafe%20slice%20of%20life%20cover%20art%2C%20cute%20cats%20and%20cafe%20owner%20characters%2C%20warm%20cozy%20cafe%20interior%20background%2C%20soft%20warm%20lighting%2C%20playful%20and%20heartwarming%20atmosphere%2C%20clean%20illustration%20style&width=600&height=840&seq=comic-cover-12&orientation=portrait',
    description: '在一条安静的街道上，有一家猫咪咖啡馆。店主收养了各种各样的流浪猫，每一只猫咪都有自己独特的性格和故事。来这里喝杯咖啡，与可爱的猫咪们共度悠闲时光吧。',
    rating: 8.9,
    views: 612000,
    tags: ['日常', '萌宠', '治愈'],
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: '12-1', title: '第1话：第一只猫', number: 1, createdAt: '2026-07-01' },
      { id: '12-2', title: '第2话：新来的小家伙', number: 2, createdAt: '2026-07-08' },
      { id: '12-3', title: '第3话：猫咪大作战', number: 3, createdAt: '2026-07-15' },
    ],
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.category === slug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getRelatedComics = (id: string, limit: number = 4): Comic[] => {
  const comic = getComicById(id);
  if (!comic) return [];
  return comics
    .filter((c) => c.id !== id && c.category === comic.category)
    .slice(0, limit);
};

export const getPopularComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getLatestComics = (limit: number = 6): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getTopRatedComics = (limit: number = 10): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
};